<template>
  <!-- 投后数据报告 -->
  <div>
    <contenr/>
    <div class="detailContainer">
      <div class="part part1">
        <span class="topName">投后数据报告</span>
        <h3>{{pageOrderBasic.order_info?pageOrderBasic.order_info[0].demand_name:'-'}}</h3>
        <div class="topInfo">
          <span>任务ID：{{pageDetailData.order?pageDetailData.order.demand_id:'-'}} </span>
          <i></i>
          <span>{{pageDetailData.order?pageDetailData.order.accept_time:'-'}}</span>
          <!-- <i></i> -->
          <!-- <span>{{pageOrderBasic.order_info?pageOrderBasic.order_info[0].industry_name:'-'}}组件</span> -->
        </div>
        <div class="content">
          <a class="backImg" :href="pageDetailData.item?pageDetailData.item.url:''" target="_blank">
              <img :src="pageDetailData.item?pageDetailData.item.cover_image_uri:''" alt="">
          </a>
          <div class="contentDetail">
            <p><a :href="pageDetailData.item?pageDetailData.item.url:''" target="_blank">{{pageDetailData.item?pageDetailData.item.title:'-'}}</a></p>
            <span><a href="javascript:void(0);">{{pageDetailData.author?pageDetailData.author.nick_name:'-'}}</a></span>
          </div>
          <div class="contentRight">
            <div class="rightItem">
              <span>{{pagePart1Data2.play?pagePart1Data2.play:'-'}}</span>
              <i>播放量</i>
            </div>
            <div class="rightItem">
              <span>{{pagePart1Data2.like?pagePart1Data2.like:'-'}}</span>
              <i>点赞量</i>
            </div>
            <div class="rightItem">
              <span>{{pagePart1Data2.comment?pagePart1Data2.comment:'-'}}</span>
              <i>评论量</i>
            </div>
            <div class="rightItem">
              <span>{{pagePart1Data2.share?pagePart1Data2.share:'-'}}</span>
              <i>分享量</i>
            </div>
            <div class="rightItem">
              <span>{{pagePart1Data2.click?pagePart1Data2.click:'-'}}</span>
              <i>组件点击量</i>
            </div>
          </div>
        </div>
        <div class="grade" v-if="false">
          <span class="title">合作评价</span>
          <span class="title2">综合表现</span>
          <div class="gradeContent">
            <div class="scort">
              <el-rate
                v-model="pageDarenWatchComment.score"
                disabled
                show-score
                text-color="#ff9900">
              </el-rate>
            </div>
            <div class="tags">
              <span v-for="(item,i) in pageDarenWatchComment.tags" :key="i">{{item}}</span>
            </div>
            <div class="tags2">
              <div class="tagItem">
                <span>内容质量：</span>
                <img v-if="pageDarenWatchComment.quality==='不满意'" src="./images/comment1.png" alt=""/>
                <img v-if="pageDarenWatchComment.quality==='满意'" src="./images/comment2.png" alt=""/>
                <img v-if="pageDarenWatchComment.quality==='非常满意'" src="./images/comment3.png" alt=""/>
                <span>{{pageDarenWatchComment.quality}}</span>
              </div>
              <div class="tagItem">
                <span>合作体验：</span>
                <img v-if="pageDarenWatchComment.experience==='不满意'" src="./images/comment1.png" alt=""/>
                <img v-if="pageDarenWatchComment.experience==='满意'" src="./images/comment2.png" alt=""/>
                <img v-if="pageDarenWatchComment.experience==='非常满意'" src="./images/comment3.png" alt=""/>
                <span>{{pageDarenWatchComment.experience}}</span>
              </div>
              <div class="tagItem">
                <span>数据效果：</span>
                <img v-if="pageDarenWatchComment.effect==='不满意'" src="./images/comment1.png" alt=""/>
                <img v-if="pageDarenWatchComment.effect==='满意'" src="./images/comment2.png" alt=""/>
                <img v-if="pageDarenWatchComment.effect==='非常满意'" src="./images/comment3.png" alt=""/>
                <span>{{pageDarenWatchComment.effect}}</span>
              </div>
            </div> 
          </div>
          <span class="title2">评价内容</span>
          <p class="comment">{{pageDarenWatchComment.evaluation?pageDarenWatchComment.evaluation:'无'}}</p>
        </div>
        <div class="index">
          <div class="progress1">
            <el-progress :percentage="pageOrderBase.index?pageOrderBase.index.video.score:0" color="#FF5C00" type="circle" :width="64" :show-text="false">
            </el-progress>
            <i>{{pageOrderBase.index?pageOrderBase.index.video.score:"-"}}</i>  
          </div>
          <span>内容表现指数</span>
          <span class="more">超过<u>{{pageOrderBase.index?pageOrderBase.index.video.rank/100:0}}%</u>的订单</span>
        </div>
        <div class="listItem">
          <div class="progress">
            <el-progress :percentage="pageOrderBase.index?pageOrderBase.index.spread.score:0" color="#FF8C4B" type="circle" :width="50" :show-text="false">
            </el-progress>
            <i>{{pageOrderBase.index?pageOrderBase.index.spread.score:"-"}}</i>  
          </div>
          <div class="listTitle">
            <span>传播表现</span>
            <u class="more">超过<em>{{pageOrderBase.index?pageOrderBase.index.spread.rank/100:0}}%</em>同类订单</u>
          </div>
          <a class="toWhere" href="#list1">详情</a>
          <ul>
            <li><span>{{pagePart1Data2.comment?pagePart1Data2.comment:'-'}}</span><i>评论量</i></li>
            <li><span>{{pagePart1Data2.play?pagePart1Data2.play:'-'}}</span><i>播放量</i></li>
            <li><span>{{pagePart1Data2.share?pagePart1Data2.share:'-'}}</span><i>分享量</i></li>
            <li><span>{{pagePart1Data2.like?pagePart1Data2.like:'-'}}</span><i>点赞量</i></li>
          </ul>
        </div>
        <div class="listItem">
          <div class="progress">
            <el-progress :percentage="pageOrderBase.index?pageOrderBase.index.cost_effectiveness.score:0" color="#FF5D6C" type="circle" :width="50" :show-text="false">
            </el-progress>
            <i>{{pageOrderBase.index?pageOrderBase.index.cost_effectiveness.score:"-"}}</i>  
          </div>
          <div class="listTitle">
            <span>性价比表现</span>
            <u class="more">超过<em>{{pageOrderBase.index?pageOrderBase.index.cost_effectiveness.rank/100:0}}%</em>同类订单</u>
          </div>
          <ul>
            <li><span>{{pagePart1Data3.price}}</span><i>订单金额</i></li>
            <li><span>{{pagePart1Data3.play}}</span><i>播放量</i></li>
            <li><span>{{pagePart1Data3.cpm}}</span><i>千次播放价格</i></li>
          </ul>
        </div>
        <div class="listItem" style="height:320px;">
          <div class="progress">
            <el-progress :percentage="pageOrderBase.index?pageOrderBase.index.audience.score:0" color="#55C5FF" type="circle" :width="50" :show-text="false">
            </el-progress>
            <i>{{pageOrderBase.index?pageOrderBase.index.audience.score:"-"}}</i>  
          </div>
          <div class="listTitle">
            <span>受众表现</span>
            <u class="more">超过<em>{{pageOrderBase.index?pageOrderBase.index.audience.rank/100:0}}%</em>同类订单</u>
          </div>
          <a class="toWhere" href="#list4">详情</a>
          <div class="listBottom">
            <span class="bottomTitle">用户画像</span>
            <div class="bottomContent">
              <img src="./images/icon_boy.png" alt="">
              <div class="bottomOther">
                <i>用户特征</i>
                <span>{{part5Echart3Data.data[part5Echart3Data.maxIndex].name}}</span>
                <span>{{part5Echart4Data.xAxisData[part5Echart4Data.maxIndex]}}</span>
                <span>{{part5Echart6Data.xAxisData[part5Echart6Data.maxIndex]}}</span>
                <span>{{part5Echart7Data.xAxisData[part5Echart7Data.maxIndex]}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="listItem" style="height:320px;">
          <div class="progress">
            <el-progress :percentage="pageOrderBase.index?pageOrderBase.index.comment.score:0" color="#31C270" type="circle" :width="50" :show-text="false">
            </el-progress>
            <i>{{pageOrderBase.index?pageOrderBase.index.comment.score:"-"}}</i>  
          </div>
          <div class="listTitle">
            <span>舆情表现</span>
            <u class="more">超过<em>{{pageOrderBase.index?pageOrderBase.index.comment.rank/100:0}}%</em>同类订单</u>
          </div>
          <a class="toWhere" href="#list5">详情</a>
          <div class="listBottom">
            <span class="bottomTitle">评论情绪分析</span>
            <div class="analysis">
              <div class="analysisItem" :style="{'width': pagePart1Data5.pos_rate + '%'}">
                <span>正向</span>
                <i></i>
                <span>{{pagePart1Data5.pos_rate?pagePart1Data5.pos_rate:'-'}}%</span>
              </div>
              <div class="analysisItem" :style="{'width': pagePart1Data5.neg_rate + '%'}">
                <span>负向</span>
                <i></i>
                <span>{{pagePart1Data5.neg_rate?pagePart1Data5.neg_rate:'-'}}%</span>
              </div>
              <div class="analysisItem" :style="{'width': pagePart1Data5.neu_rate + '%'}">
                <span>中立</span>
                <i></i>
                <span>{{pagePart1Data5.neu_rate?pagePart1Data5.neu_rate:'-'}}%</span>
              </div>
            </div>
            <div class="bottomContent">
              <div class="bottomOther" style="margin-left:0;">
                <u>评论高频词：</u>
                <span v-for="(item,i) in pagePart1Data5.high_frequency_words" :key="i">{{item}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="listItem">
          <div class="progress">
            <el-progress :percentage="pageOrderBase.index?pageOrderBase.index.convert.score:0" color="#C16CE1" type="circle" :width="50" :show-text="false">
            </el-progress>
            <i>{{pageOrderBase.index?pageOrderBase.index.convert.score:"-"}}</i>  
          </div>
          <div class="listTitle">
            <span>转化表现</span>
            <u class="more">超过<em>{{pageOrderBase.index?pageOrderBase.index.convert.rank/100:0}}%</em>同类订单</u>
          </div>
          <a class="toWhere" href="#list2">详情</a>
          <ul>
            <li><span>{{pagePart1Data6.click?pagePart1Data6.click:'-'}}</span><i>点击量</i></li>
            <li><span>{{pagePart1Data6.ctr?pagePart1Data6.ctr:'-'}}%</span><i>点击率</i></li>
          </ul>
        </div>
        <div class="listItem">
          <div class="progress">
            <el-progress :percentage="pageOrderBase.index?pageOrderBase.index.creative.score:0" color="#7F6FF6" type="circle" :width="50" :show-text="false">
            </el-progress>
            <i>{{pageOrderBase.index?pageOrderBase.index.creative.score:"-"}}</i>  
          </div>
          <div class="listTitle">
            <span>创意表现</span>
            <u class="more">超过<em>{{pageOrderBase.index?pageOrderBase.index.creative.rank/100:0}}%</em>同类订单</u>
          </div>
          <a class="toWhere" href="#list3">详情</a>
          <ul>
            <li><span>{{pagePart1Data7.finish_rate?pagePart1Data7.finish_rate:'-'}}%</span><i>视频5s播放率</i></li>
            <li><span>{{pagePart1Data7.five_s_play_rate?pagePart1Data7.five_s_play_rate:'-'}}%</span><i>视频完播率</i></li>
            <li><span>{{pagePart1Data7.play_rate?pagePart1Data7.play_rate:'-'}}%</span><i>视频平均播放率</i></li>
          </ul>
        </div>
      </div>
      <div class="part part2" v-if="false">
        <div class="partTitle">
          <div class="partTitleLeft">
            <a class="partTitleLeftTit" name="list1">传播表现</a>
            <p>包括本次投放的播放、点赞、评论、转发、主页导流水平</p>
            <i></i>
            <p>更新时间: {{upDateTime}} 00:00:00</p>
          </div>
          <div class="progress">
            <el-progress :percentage="pageOrderBase.index?pageOrderBase.index.spread.score:0" color="#FF8C4B" type="circle" :width="50" :show-text="false">
            </el-progress>
            <i>{{pageOrderBase.index?pageOrderBase.index.spread.score:"-"}}</i>  
          </div>
          <u class="more">超越<em>{{pageOrderBase.index?pageOrderBase.index.spread.rank/100:0}}%</em>同行业订单</u>
        </div>
        <div class="hr"></div>
        <span class="title2">视频数据</span>
        <el-tabs v-model="part2ActiveName" @tab-click="part2HandleClick">
          <el-tab-pane label="分日数据" name="分日数据"></el-tab-pane>
          <el-tab-pane label="累积数据" name="累积数据"></el-tab-pane>
        </el-tabs>
        <div class="chooseTime" v-if="part2Time1.length!==0">
          <span class="time">
            <div class="block">
              <el-date-picker
                v-model="part2Time1"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="changePart2Time1"
                :picker-options="pickerOptions">
              </el-date-picker>
            </div>
          </span>
        </div>
        <div v-show="!pageOrderStatics" class="part1Echar1Nodata">
          <div class="noData"><img src="./images/nodata.png"/><span>暂无数据</span></div>
        </div>
        <LineChart2 :lineChart2Info="part2Echart1Data" ref="detailPart2Chart1"></LineChart2>
        <span class="title2">实时视频数据
          <div class="block">
            <el-date-picker
              v-model="part2Time2"
              @change="changePart2Time2"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </div>
        </span>
        <div v-show="!isShowPart2Echart2" class="part1Echar2Nodata">
          <div class="noData"><img src="./images/nodata.png"/><span>暂无数据</span></div>
        </div>
        <LineChart2 :lineChart2Info="part2Echart2Data" ref="detailPart2Chart2"></LineChart2>
      </div>
      <div class="part part3" v-if="false">
        <div class="partTitle">
          <div class="partTitleLeft">
            <a class="partTitleLeftTit" name="list2">转化表现</a>
            <p>包括本次投放的组件点击量、组件点击率水平</p>
            <i></i>
            <p>更新时间: {{upDateTime}} 00:00:00</p>
          </div>
          <div class="progress">
            <el-progress :percentage="pageOrderBase.index?pageOrderBase.index.convert.score:0" color="#C16CE1" type="circle" :width="50" :show-text="false">
            </el-progress>
            <i>{{pageOrderBase.index?pageOrderBase.index.convert.score:"-"}}</i>  
          </div>
          <u class="more">超越<em>{{pageOrderBase.index?pageOrderBase.index.convert.rank/100:0}}%</em>同行业订单</u>
        </div>
        <div class="hr"></div>
        <el-tabs v-model="part3ActiveName" @tab-click="part3HandleClick">
          <el-tab-pane label="分日数据" name="分日数据"></el-tab-pane>
          <el-tab-pane label="累积数据" name="累积数据"></el-tab-pane>
        </el-tabs>
        <div class="chooseTime">
          <div class="time">
            <div class="block">
              <el-date-picker
                v-model="part3Time1"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="~"
                start-placeholder=""
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="changePart3Time1"
                :picker-options="pickerOptions">
              </el-date-picker>
            </div>
          </div>
        </div>
        <div v-show="pageOrderComponent.stat_list&&pageOrderComponent.stat_list.length===0" class="part1Echar2Nodata">
          <div class="noData"><img src="./images/nodata.png"/><span>暂无数据</span></div>
        </div>
        <LineChart2 :lineChart2Info="part3Echart1Data" ref="detailPart3Chart1"></LineChart2>
      </div>
      <div class="part part4">
        <div class="partTitle">
          <div class="partTitleLeft">
            <a class="partTitleLeftTit" name="list3">创意表现</a>
            <p>包括本次投放的第一印象、平均注意力和内容韧性</p>
            <i></i>
            <p>更新时间: {{this.upDateTime}} 00:00:00</p>
          </div>
          <div class="progress">
            <el-progress :percentage="pageOrderBase.index?pageOrderBase.index.creative.score:0" color="#7F6FF6" type="circle" :width="50" :show-text="false">
            </el-progress>
            <i>{{pageOrderBase.index?pageOrderBase.index.creative.score:"-"}}</i>  
          </div>
          <u class="more">超越<em>{{pageOrderBase.index?pageOrderBase.index.creative.rank/100:0}}%</em>同行业订单</u>
        </div>
        <div class="hr"></div>
        <div class="ItemContainer">
          <span class="ItemTitle">观看时长曲线</span>
          <ul class="part4List1">
            <li><span>39.8%</span><i>5s播放率</i></li>
            <li><span>22.8%</span><i>平均播放率</i></li>
            <li><span>39.8%</span><i>完播率</i></li>
          </ul>
          <LineChart3 :lineChartInfo="part4Echart1Data" ref="detailPart4Chart1"></LineChart3>
        </div>
        <div class="ItemContainer">
          <span class="ItemTitle">创意解析</span>
          <RadarChart :radarChartInfo="part4Echart2Data" ref="detailPart4Chart2"></RadarChart>
          <ul class="part4List2">
            <li><span>内容吸引力</span><i>{{pageOrderCreative.content_appeal?pageOrderCreative.content_appeal.level:'-'}}</i><span>{{pageOrderCreative.content_appeal?pageOrderCreative.content_appeal.text:'-'}}</span></li>
            <li><span>第一印象</span><i>{{pageOrderCreative.first_impression?pageOrderCreative.first_impression.level:'-'}}</i><span>{{pageOrderCreative.first_impression?pageOrderCreative.first_impression.text:'-'}}</span></li>
            <li><span>内容韧性</span><i>{{pageOrderCreative.content_resilience?pageOrderCreative.content_resilience.level:'-'}}</i><span>{{pageOrderCreative.content_resilience?pageOrderCreative.content_resilience.text:'-'}}</span></li>
          </ul>
        </div>
      </div>
      <div class="part part5">
        <div class="partTitle">
          <div class="partTitleLeft">
            <a class="partTitleLeftTit" name="list4">受众表现</a>
            <p>包含本次投后的受众活跃度、受众转化率</p>
            <i></i>
            <p>更新时间: {{upDateTime}} 00:00:00</p>
          </div>
          <div class="progress">
            <el-progress :percentage="pageOrderBase.index?pageOrderBase.index.audience.score:0" color="#55C5FF" type="circle" :width="50" :show-text="false">
            </el-progress>
            <i>{{pageOrderBase.index?pageOrderBase.index.audience.score:"-"}}</i>  
          </div>
          <u class="more">超越<em>{{pageOrderBase.index?pageOrderBase.index.audience.rank/100:0}}%</em>同行业订单</u>
        </div>
        <div class="hr"></div>
        <div class="userChoose">
          <span>用户行为筛选：</span>
          <i :class="part5UserChoose=='播放'?'active':''" @click="userChoose">播放</i>
          <i :class="part5UserChoose=='分享'?'active':''" @click="userChoose">分享</i>
          <i :class="part5UserChoose=='点赞'?'active':''" @click="userChoose">点赞</i>
          <i :class="part5UserChoose=='评论'?'active':''" @click="userChoose">评论</i>
        </div>
        <div class="part5Line1">
          <span class="title2">用户地域</span>
            <el-tabs v-model="part5ActiveName" @tab-click="part5HandleClick">
              <el-tab-pane label="省份" name="省份"></el-tab-pane>
              <el-tab-pane label="城市" name="城市"></el-tab-pane>
            </el-tabs>
            <div class="part5Chart1Container" v-show="part5ActiveName==='省份'">
              <ChinaChart1 :chinaChartInfo="chinaChartInfo1" ref="detailPart5Chart1"></ChinaChart1>
            </div>
            <div class="part5Chart1Container" v-show="part5ActiveName==='城市'">
              <ChinaChart2 :chinaChartInfo="chinaChartInfo2" ref="detailPart5Chart2"></ChinaChart2>
            </div>
            <div class="part5Chart2Container" v-show="part5ActiveName=='省份'">
              <u class="more">用户分布最多的3个省份为<em>
                <span v-for="(item,i) in chinaData.slice(0,3)" :key="i">{{item.name}}（{{parseInt(item.value)}}%） </span></em>
              </u>
              <div class="part5Progress"> 
                <el-tooltip  v-for="(item,i) in chinaData.slice(0,5)" :key="i" effect="dark" :content="item.name +' : '+ item.value+'%'" placement="top">
                  <div><span>{{item.name}}</span><el-progress :percentage="parseInt(item.value)" :stroke-width="14"></el-progress></div>
                </el-tooltip>
              </div>
            </div>
            <div class="part5Chart2Container" v-show="part5ActiveName=='城市'">
              <u class="more">用户分布最多的3个城市为<em>
                <span v-for="(item,i) in chinaCityData.slice(0,3)" :key="i">{{item.name}}（{{parseInt(item.value)}}%） </span></em>
              </u>
              <div class="part5Progress">
                <el-tooltip  v-for="(item,i) in chinaCityData.slice(0,5)" :key="i" effect="dark" :content="item.name +' : '+ item.value+'%'" placement="top">
                  <div><span>{{item.name}}</span><el-progress :percentage="parseInt(item.value)" :stroke-width="14"></el-progress></div>
                </el-tooltip>
              </div>
            </div>
        </div>
        <div class="part5Echart3Container">
          <span class="title2">性别分布</span>
          <u class="more"><em>{{part5Echart3Data.data[part5Echart3Data.maxIndex].name}}</em>用户最多，占比<em>{{part5Echart3Data.data[part5Echart3Data.maxIndex].value}}%</em></u>
          <RingChart :ringChartInfo="part5Echart3Data" ref="detailPart5Chart3"></RingChart>
          <div class="bottom">
            <img src="./images/icon_gril.png" alt="">
            <div class="bottomRight">
              <span>女性</span>
              <i>{{part5Echart3Data.data[0].value}}%</i>
            </div>
          </div>
          <div class="bottom">
            <img src="./images/icon_boy.png" alt="">
            <div class="bottomRight">
              <span>男性</span>
              <i>{{part5Echart3Data.data[1].value}}%</i>
            </div>
          </div>
        </div>
        <div class="part5Echart4Container">
          <span class="title2">平均年龄</span>
          <u class="more"><em>{{part5Echart4Data.xAxisData[part5Echart4Data.maxIndex]}}</em>用户最多，占比<em>{{part5Echart4Data.data[part5Echart4Data.maxIndex]}}%</em></u>
          <BarChart :barChartInfo="part5Echart4Data" ref="detailPart5Chart4"></BarChart>
        </div>
        <div class="part5Echart5Container">
          <span class="title2">用户活跃度</span>
          <u class="more">观看视频用户的抖音活跃度一般 ，重度活跃用户占比<em>{{part5Echart5Data.data[part5Echart5Data.maxIndex].value}}%</em></u>
          <RingChart :ringChartInfo="part5Echart5Data" ref="detailPart5Chart5"></RingChart>
        </div>
        <div class="part5Echart6Container">
          <span class="title2">用户设备</span>
          <u class="more">{{part5Echart6Data.xAxisData[part5Echart6Data.maxIndex]}}手机占比<em>{{part5Echart6Data.data[part5Echart6Data.maxIndex]}}%</em>，用户消费能力一般</u>
          <BarChart :barChartInfo="part5Echart6Data" ref="detailPart5Chart6"></BarChart>
        </div>
        <div class="part5Echart7Container">
          <span class="title2">兴趣分布</span>
          <u class="more">视频受众最感兴趣的三种内容类型为
            <em><span v-for="(item,i) in part5Echart7Data.xAxisData.slice(0,3)" :key="i">{{item}} </span></em>
          </u>
          <BarChart :barChartInfo="part5Echart7Data" ref="detailPart5Chart7"></BarChart>
        </div>
      </div>
      <div class="part part6">
        <div class="partTitle">
          <div class="partTitleLeft">
            <a class="partTitleLeftTit" name="list5">舆情表现</a>
            <p>包括本次投放的词云、正负向评论情况</p>
            <i></i>
            <p>更新时间: {{upDateTime}} 00:00:00</p>
          </div>
          <div class="progress">
            <el-progress :percentage="pageOrderBase.index?pageOrderBase.index.comment.score:0" color="#FF5D6C " type="circle" :width="50" :show-text="false">
            </el-progress>
            <i>{{pageOrderBase.index?pageOrderBase.index.comment.score:"-"}}</i>  
          </div>
          <u class="more">超越<em>{{pageOrderBase.index?pageOrderBase.index.comment.rank/100:0}}%</em>同行业订单</u>
        </div>
        <div class="hr"></div>
        <div class="part6Echart1Container">
          <span class="title2">评论热词</span>
          <div class="hotword">
              <span v-for="(item,i) in pagePart6Data1" :key="i">{{item}}</span>
          </div>
        </div>
        <div class="part6Echart2Container">
          <span class="title2">评论情绪分析</span>
          <RingChart :ringChartInfo="part6Echart2Data" ref="detailPart6Chart2"></RingChart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contenr from "../content"
import LineChart3 from "../../components/Echart/LineChart3.vue"
import LineChart2 from "../../components/Echart/LineChart2.vue"
import BarChart from '../../components/Echart/BarChart.vue';
import RadarChart from '../../components/Echart/RadarChart.vue';
import RingChart from "../../components/Echart/RingChart.vue";
import ChinaChart2 from "../../components/Echart/ChinaChart2.vue";
import ChinaChart1 from "../../components/Echart/ChinaChart1.vue";
import tools from "../../components/tools/tools.js";


export default {
  name: "Detail",
  props:[],
  data(){
    return {
      orderID:0,
      isInit:true,
      //
      pickerOptions: {
        shortcuts: [{
          text: '发布后3天',
          onClick(picker) {
            const end = new Date();
            const start = new Date(tools.detailStartTime);
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', [start, end]);
          }
        },{
          text: '发布后7天',
          onClick(picker) {
            const end = new Date();
            const start = new Date(tools.detailStartTime);
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '发布后14天',
          onClick(picker) {
            const end = new Date();
            const start = new Date(tools.detailStartTime);
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 14);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      part2Time1: [],
      part2Time2: '',
      part3Time1: [],
      upDateTime:'',
      //
      pageDarenWatchComment:{
        score:0,
        tags:[],
        quality:'-',
        experience:'-',
        effect:'-',
      },
      pageOrderDistri:{},
      pageOrderComponent:{},
      pageDetailReal:{},
      pageDetailData:{},
      pageOrderWatch:{},
      pageOrderCreative:{},
      pageOrderBase:{},
      pageOrderStatics:{},
      pageOrderBasic:{},
      pageSuccessExample:{},
      pageOrderOverview:{},
      pageOrderUser:{},
      // 顶部
      pagePart1Data1:{},
      // 传播表现
      pagePart1Data2:{},
      // 性价比表现
      pagePart1Data3:{},
      // 受众表现
      pagePart1Data4:{},
      // 舆情表现
      pagePart1Data5:{},
      // 转化表现
      pagePart1Data6:{},
      // 创意表现
      pagePart1Data7:{},
      // 评论热词
      pagePart6Data1:[],

      percentage:28,
      part2ActiveName:"分日数据",
      part2Command:"发布后3天",
      //part2 图表 分日数据
      part2Echart1Data:{
        nodeId:'detailPart2Echart1',
        data1: [0],//数据
        data2: [0],//数据
        data3: [0],//数据
        data4: [0],//数据
        dataName:['播放量','点赞量','评论量','分享量'],
        smooth:true,//平滑
        xAxisData:['-'],
        yAxisName: '',
        tooltipName:'',
        unit:''
      },
      part2Echart2Data:{
        nodeId:'detailPart2Echart2',
        data1: [0],//数据
        data2: [0],//数据
        data3: [0],//数据
        data4: [0],//数据
        dataName:['播放量','点赞量','评论量','分享量'],
        smooth:true,//平滑
        xAxisData:['-'],
        yAxisName: '',
        tooltipName:'用户占比',
        unit:''
      },
      isShowPart2Echart2:false,
      //part3 图表
      part3ActiveName:"分日数据",
      part3Echart1Data:{
        nodeId:'detailPart3Echart1',
        data1: [0],//数据
        data2: [0],//数据
        data3: [0],//数据
        dataName:['展示量','点击量','点击率'],
        smooth:true,//平滑
        xAxisData:['-'],
        min:14, //y轴的最小值
        max:0, //y轴最大值 
        interval:2, //值之间的间隔
        yAxisName: '',
        tooltipName:'用户占比',
        unit:''
      },
      //观看时长曲线echart
      part4Echart1Data:{
        nodeId:'detailPart4Echart1',//节点
        data: [0],//数据
        smooth:true,//平滑
        xAxisData:['-'],
        yAxisName: '',
        tooltipName2:'观看时长',
        tooltipName:'用户占比',
        unit:''
      },
      //创意解析echart
      part4Echart2Data:{
        nodeId:'detailPart4Echart2',//节点
        max:[{text: '内容吸引力 A-', max: 100},{text: '内容韧性 B', max: 100},{text: '第一印象 A', max: 100}],
        data1:[0,0,0],
        data2:[0,0,0]
      },
      part5UserChoose:"播放",
      // part5 全国地图
      part5ActiveName: "省份",
      chinaData: [],
      chinaCityData:[],
      //part5 全国散点图
      chinaChartInfo2:{
        nodeId:'detailPart5Echart2',//节点
        data: []//数据
      },
      chinaChartInfo1:{
        nodeId:'detailPart5Echart1',//节点
        data: []//数据
      },
      //part5 性别分布
      part5Echart3Data:{
          nodeId:'detailPart5Echart3',//节点
          data: [{value: 0, name: '女性'},{value: 0, name: '男性'},],//数据
          color:["#ff5c00","#40a0fc"],
          guideline:true,
          tooltipName:'粉丝总量',
          unit:'%',
          maxIndex:0
      },
      //part5 平均年龄
      part5Echart4Data: {
        nodeId: "detailPart5Echart4", //节点
        data: [0], //数据
        color: ["#ff5c00", "#40a0fc"],
        xAxisData: ["-"],
        min: 0, //y轴的最小值
        max: 60, //y轴最大值
        interval: 10, //值之间的间隔
        yAxisName: "",
        tooltipName: "年龄占比",
        unit: "%",
        formatter: function (params) {
          let vals=params[0].data
          if(vals>=10000){
            vals=(vals/10000).toFixed(2)+barChartInfo.unit
          }
          return '<div>'+barChartInfo.tooltipName+'：'+params[0].name+'</div><div>'+ params[0].seriesName+' '+ vals+'</div>'
        },
        maxIndex:0
      },
      //part5 用户活跃度
      part5Echart5Data: {
        nodeId: "detailPart5Echart5", //节点
        data: [{value: 0,name: "-"}], //数据
        color: ["#2074ff","#38a1ff","#77bfff","#a7d6ff","#d0e9ff","#def0ff",],
        unit: "%",
        maxIndex:0,
        guideline: true, //引导线
      },
      //part5 用户设备
      part5Echart6Data: {
        nodeId: "detailPart5Echart6", //节点
        data: [0], //数据
        color: ["#ff5c00", "#40a0fc"],
        xAxisData: ["-"],
        min: 0, //y轴的最小值
        max: 40, //y轴最大值
        interval: 10, //值之间的间隔
        yAxisName: "",
        tooltipName: "年龄占比",
        unit: "%",
        formatter: function (params) {
          let vals=params[0].data
          if(vals>=10000){
            vals=(vals/10000).toFixed(2)+barChartInfo.unit
          }
          return '<div>年龄分布</div>'+'<div>'+params[0].name +' : '+ params[0].seriesName+' '+ vals+'%</div>'
        },
        maxIndex:0
      },
      //part5 兴趣分布
      part5Echart7Data: {
        nodeId: "detailPart5Echart7", //节点
        data: [0], //数据
        color: ["#ff5c00", "#40a0fc"],
        xAxisData: ["-"],
        min: 0, //y轴的最小值
        max: 40, //y轴最大值
        interval: 10, //值之间的间隔
        yAxisName: "",
        tooltipName: "年龄占比",
        unit: "%",
        formatter: function (params) {
          let vals=params[0].data
          if(vals>=10000){
            vals=(vals/10000).toFixed(2)+barChartInfo.unit
          }
          return '<div>年龄分布</div>'+'<div>'+params[0].name +' : '+ params[0].seriesName+' '+ vals+'%</div>'
        },
        maxIndex:0
      },
      //part6 评论情绪分析
      part6Echart2Data:{
        nodeId:'detailPart6Echart2',//节点
        data: [{value: 0, name: '正向评论'},{value: 0, name: '负向评论'},{value: 0, name: '中立'}],//数据
        color:["#FF7936","#40A0FC","#C9CED4"],
        guideline:true,
        unit:'%'
      },
    }
  },
  computed:{
  },
  methods:{
    //三位数以上加逗号
    toThousands(num) {
      var num = (num || 0).toString(), result = '';
      while (num.length > 3) {
          result = ',' + num.slice(-3) + result;
          num = num.slice(0, num.length - 3);
      }
      if (num) { result = num + result; }
      return result;
    },
    toChangeW(num){
      if(num > 9999){
        return (Math.floor(num/1000)/10) + 'w'
      }
      return num
    },
    //进度条
    format(percentage){
      return percentage
    },
    //part2 发布时间
    part2HandleClick(tab, event) {
      this.part2ActiveName = tab.name
      // 分日数据
      let part2Echart1Data={
        nodeId:'detailPart2Echart1',
        data1: [],//数据
        data2: [],//数据
        data3: [],//数据
        data4: [],//数据
        dataName:['播放量','点赞量','评论量','分享量'],
        smooth:true,//平滑
        xAxisData:[],
        yAxisName: '',
        tooltipName:'',
        unit:''
      }
      //累积数据
      let part2Echart1Data2={
        nodeId:'detailPart2Echart1',
        data1: [],//数据
        data2: [],//数据
        data3: [],//数据
        data4: [],//数据
        dataName:['播放量','点赞量','评论量','分享量'],
        smooth:true,//平滑
        xAxisData:[],
        yAxisName: '',
        tooltipName:'',
        unit:''
      }
      this.pageOrderStatics.length&&this.pageOrderStatics.forEach(function(item,i){
        // 分日数据
        part2Echart1Data.xAxisData.push(item.date)
        part2Echart1Data.data1.push(item.action_statistics.play)
        part2Echart1Data.data2.push(item.action_statistics.like)
        part2Echart1Data.data3.push(item.action_statistics.comment)
        part2Echart1Data.data4.push(item.action_statistics.share)
        //累积数据
        part2Echart1Data2.xAxisData.push(item.date)
        part2Echart1Data2.data1.push(item.cultimate_action_statistics.play)
        part2Echart1Data2.data2.push(item.cultimate_action_statistics.like)
        part2Echart1Data2.data3.push(item.cultimate_action_statistics.comment)
        part2Echart1Data2.data4.push(item.cultimate_action_statistics.share)
      })
    
      if(tab.name==="分日数据"){
        this.part2Echart1Data = part2Echart1Data
      }else if(tab.name==="累积数据"){
        this.part2Echart1Data = part2Echart1Data2
      }
      this.$refs.detailPart2Chart1.lineChart2(this.part2Echart1Data)

    },
    changePart2Time1(){
      this.part2Time1Ajax(this.part2Time1,this.part2ActiveName)
    },
    changePart2Time2(){
      this.part2Time2Ajax(tools.setTime(this.part2Time2.getTime()/1000))
    },
    part2Time1Ajax(part2Time1,tagName){
      this.$api.getDetailData.getOrderStatics('/'+this.orderID,'start_time='+part2Time1[0]+' 00:00:00&end_time='+part2Time1[1]+' 00:00:00').then((res) => {
        this.pageOrderStatics = res.data.data
        tools.detailStartTime=this.pageOrderStatics[0].date
        if(res.data.data){
          this.part2HandleClick({name:tagName})
        }
      })
    },
    part2Time2Ajax(part2Time2){
      this.$api.getDetailData.getOrderReal('/'+this.orderID,'day='+part2Time2).then((res) => {
        this.pageOrderReal = res.data.data

        this.part2Time2 = tools.setTime(Date.parse(new Date())/1000)
        if(this.pageOrderReal.statistics==='[]'){
          this.isShowPart2Echart2=false
        }else{
          this.isShowPart2Echart2=true
        }
        let statistics = JSON.parse(this.pageOrderReal.statistics)
        let part2Echart2Data={
          nodeId:'detailPart2Echart2',
          data1: [],//数据
          data2: [],//数据
          data3: [],//数据
          data4: [],//数据
          dataName:['播放量','点赞量','评论量','分享量'],
          smooth:true,//平滑
          xAxisData:[],
          yAxisName: '',
          tooltipName:'',
          unit:''
        }
        statistics.forEach(function(item){
          part2Echart2Data.xAxisData.push(tools.setTime(item.time,2))
          part2Echart2Data.data1.push(item.play_action)
          part2Echart2Data.data2.push(item.digg_action)
          part2Echart2Data.data3.push(item.comment_action)
          part2Echart2Data.data4.push(item.share_action)
        })
        this.part2Echart2Data = part2Echart2Data
        this.$refs.detailPart2Chart2.lineChart2(this.part2Echart2Data)
      })
    },
    //part3
    part3HandleClick(tab, event) {
      // 分日数据
      let part3Echart1Data={
        nodeId:'detailPart3Echart1',
        data1: [],//数据
        data2: [],//数据
        data3: [],//数据
        dataName:['展示量','点击量','点击率'],
        smooth:true,//平滑
        xAxisData:[],
        yAxisName: '',
        tooltipName:'',
        unit:''
      }
      //累积数据
      let part3Echart1Data2={
        nodeId:'detailPart3Echart1',
        data1: [],//数据
        data2: [],//数据
        data3: [],//数据
        dataName:['展示量','点击量','点击率'],
        smooth:true,//平滑
        xAxisData:[],
        yAxisName: '',
        tooltipName:'',
        unit:''
      }
      this.pageOrderComponent.stat_list.forEach(function(item){
        // 分日数据
        part3Echart1Data.xAxisData.push(tools.setTime(item.date-0))
        part3Echart1Data.data1.push(item.daily_statistics.vv)
        part3Echart1Data.data2.push(item.daily_statistics.click)
        part3Echart1Data.data3.push(item.daily_statistics.vv_click_rate)
        //累积数据
        part3Echart1Data2.xAxisData.push(tools.setTime(item.date-0))
        part3Echart1Data2.data1.push(item.cultimate_statistics.vv)
        part3Echart1Data2.data2.push(item.cultimate_statistics.click)
        part3Echart1Data2.data3.push(item.cultimate_statistics.vv_click_rate)
      })
      
      if(tab.name==="分日数据"){
        this.part3Echart1Data = part3Echart1Data
      }else if(tab.name==="累积数据"){
        this.part3Echart1Data = part3Echart1Data2
      }
      this.$refs.detailPart3Chart1.lineChart2(this.part3Echart1Data)

    },
    changePart3Time1(){
      this.part3Time1Ajax(this.part3Time1,this.part3ActiveName)
    },
    part3Time1Ajax(part3Time1,tagName){
      this.$api.getDetailData.getOrderComponent('/'+this.orderID,'start_time='+part3Time1[0]+' 00:00:00&end_time='+part3Time1[1]+' 00:00:00').then((res) => {
        this.pageOrderComponent = res.data.data
        if(res.data.data){
          this.part3HandleClick({name:tagName})
        }
      })
    },
    //part5 用户行为筛选
    userChoose(e){
      this.part5UserChoose=e.target.innerHTML
      this.part5DataAjax(this.part5UserChoose)
    },
    // 全国地图tag
    part5HandleClick(tab, event) {
      this.part5ActiveName=tab.name
    },
    part5DataAjax(tagName){
      if(tagName=="播放"){
        if(window.sessionStorage.getItem('getOrderDistri1')){
          this.pageOrderDistri = JSON.parse(window.sessionStorage.getItem('getOrderDistri1')).data.data.item_user_distribution
          this.part5DataDrawing()
        }else{
          this.$api.getDetailData.getOrderDistri('/'+this.orderID,'metric_type=1').then((res) => {
            window.sessionStorage.setItem('getOrderDistri1',JSON.stringify(res));
            this.pageOrderDistri = JSON.parse(window.sessionStorage.getItem('getOrderDistri1')).data.data.item_user_distribution
            this.part5DataDrawing()
          })
        }
      }else if(tagName==="点赞"){
        if(window.sessionStorage.getItem('getOrderDistri2')){
          this.pageOrderDistri = JSON.parse(window.sessionStorage.getItem('getOrderDistri2')).data.data.item_user_distribution
          this.part5DataDrawing()
        }else{
          this.$api.getDetailData.getOrderDistri('/'+this.orderID,'metric_type=2').then((res) => {
            window.sessionStorage.setItem('getOrderDistri2',JSON.stringify(res));
            this.pageOrderDistri = JSON.parse(window.sessionStorage.getItem('getOrderDistri2')).data.data.item_user_distribution
            this.part5DataDrawing()
          })
        }
      }else if(tagName==="评论"){
        if(window.sessionStorage.getItem('getOrderDistri3')){
          this.pageOrderDistri = JSON.parse(window.sessionStorage.getItem('getOrderDistri3')).data.data.item_user_distribution
          this.part5DataDrawing()
        }else{
          this.$api.getDetailData.getOrderDistri('/'+this.orderID,'metric_type=3').then((res) => {
            window.sessionStorage.setItem('getOrderDistri3',JSON.stringify(res));
            this.pageOrderDistri = JSON.parse(window.sessionStorage.getItem('getOrderDistri3')).data.data.item_user_distribution
            this.part5DataDrawing()
          })
        }
      }else if(tagName==="分享"){
        if(window.sessionStorage.getItem('getOrderDistri4')){
          this.pageOrderDistri = JSON.parse(window.sessionStorage.getItem('getOrderDistri4')).data.data.item_user_distribution
          this.part5DataDrawing()
        }else{
          this.$api.getDetailData.getOrderDistri('/'+this.orderID,'metric_type=4').then((res) => {
            window.sessionStorage.setItem('getOrderDistri4',JSON.stringify(res));
            this.pageOrderDistri = JSON.parse(window.sessionStorage.getItem('getOrderDistri4')).data.data.item_user_distribution
            this.part5DataDrawing()
          })
        }
      }

    },
    part5DataDrawing(){
      // part5 省份 province_distribution 
      let chinaData = []
      let chinaProvinceSum = 0
      this.pageOrderDistri.province_distribution.forEach(function(item,i){
        chinaProvinceSum+=item.value
      })
      this.pageOrderDistri.province_distribution.forEach(function(item,i){
        let obj={
          name: item.key,
          value: ((item.value/chinaProvinceSum)*100).toFixed(2)-0
        }
        chinaData.push(obj)
      })
      this.chinaData = chinaData
      this.chinaChartInfo1.data = this.chinaData
      if(!this.isInit){
        this.$refs.detailPart5Chart1.chinaChart(this.chinaChartInfo1)
      }

      // part5 城市 city_distribution
      let chinaCityData = []
      let chinaCitySum = 0
      this.pageOrderDistri.city_distribution.forEach(function(item,i){
        chinaCitySum+=item.value
      })
      this.pageOrderDistri.city_distribution.forEach(function(item,i){
        let obj={
          name: item.key,
          value: ((item.value/chinaCitySum)*100).toFixed(2)-0
        }
        chinaCityData.push(obj)
      })
      this.chinaCityData = chinaCityData
      this.chinaChartInfo2.data = this.chinaCityData
      if(!this.isInit){
        this.$refs.detailPart5Chart2.chinaChart(this.chinaChartInfo2)
      }

      //part5 性别分布 gender_distribution
      let part5Echart3Data={
          nodeId:'detailPart5Echart3',//节点
          data: [{value: 0, name: '女性'},{value: 0, name: '男性'},],//数据
          color:["#ff5c00","#40a0fc"],
          guideline:true,
          tooltipName:'粉丝总量',
          unit:'%',
          maxIndex:0
      }
      part5Echart3Data.data[0].value =parseInt((this.pageOrderDistri.gender_distribution[0].value/(this.pageOrderDistri.gender_distribution[0].value+this.pageOrderDistri.gender_distribution[1].value))*100)
      part5Echart3Data.data[1].value = 100 - part5Echart3Data.data[0].value
      part5Echart3Data.maxIndex = (part5Echart3Data.data[0].value>part5Echart3Data.data[1].value)?0:1
      this.part5Echart3Data=part5Echart3Data
      if(!this.isInit){
        this.$refs.detailPart5Chart3.ringChart(this.part5Echart3Data)
      }

      //part5 平均年龄 age_distribution
      let part5Echart4Data={
        nodeId: "detailPart5Echart4", //节点
        data: [], //数据
        color: ["#ff5c00", "#40a0fc"],
        xAxisData: [],
        min: 0, //y轴的最小值
        max: 60, //y轴最大值
        interval: 10, //值之间的间隔
        yAxisName: "",
        tooltipName: "年龄占比",
        unit: "%",
        maxIndex:0,
        formatter: function (params) {
          let vals=params[0].data
          if(vals>=10000){
            vals=(vals/10000).toFixed(2)+barChartInfo.unit
          }
          return '<div>年龄分布</div>'+'<div>'+params[0].name +' : '+ params[0].seriesName+' '+ vals+'%</div>'
        }
      }
      let part5Echart4Sum = 0
      this.pageOrderDistri.age_distribution.forEach(function(item,i){
        part5Echart4Sum+=item.value
      })
      this.pageOrderDistri.age_distribution.forEach(function(item,i){
        part5Echart4Data.xAxisData.push(item.key)
        part5Echart4Data.data.push((item.value*100/part5Echart4Sum).toFixed(2)-0)
      })

      part5Echart4Data.maxIndex = tools.arrayMax(part5Echart4Data.data,'index')

      this.part5Echart4Data = part5Echart4Data
      if(!this.isInit){
        this.$refs.detailPart5Chart4.barChart(this.part5Echart4Data)
      }

      //part5 用户活跃度  activity_distribution
      let part5Echart5Data= {
        nodeId: "detailPart5Echart5", //节点
        data: [], //数据
        color: ["#2074ff","#38a1ff","#77bfff","#a7d6ff","#d0e9ff","#def0ff",],
        unit: "%",
        guideline: true, //引导线
        maxIndex:0
      }
      let part5Echart5Sum = 0
      let part5Echart5DataArr = []
      this.pageOrderDistri.activity_distribution.forEach(function(item,i){
        part5Echart5Sum+=item.value
      })
      this.pageOrderDistri.activity_distribution.forEach(function(item,i){
        let obj = {
            value: (item.value*100/part5Echart5Sum).toFixed(2)-0,
            name: item.key
          }
        part5Echart5Data.data.push(obj)
        part5Echart5DataArr.push((item.value*100/part5Echart5Sum).toFixed(2)-0)
      })
      part5Echart5Data.maxIndex =tools.arrayMax(part5Echart5DataArr,'index')
      this.part5Echart5Data= part5Echart5Data
      if(!this.isInit){
        this.$refs.detailPart5Chart5.ringChart(this.part5Echart5Data)
      }

      //part5 用户设备 device_distribution
      let part5Echart6Data={
        nodeId: "detailPart5Echart6", //节点
        data: [], //数据
        color: ["#ff5c00", "#40a0fc"],
        xAxisData: [],
        min: 0, //y轴的最小值
        max: 40, //y轴最大值
        interval: 10, //值之间的间隔
        yAxisName: "",
        tooltipName: "设备分布",
        unit: "%",
        maxIndex:0,
        formatter: function (params) {
          let vals=params[0].data
          if(vals>=10000){
            vals=(vals/10000).toFixed(2)+barChartInfo.unit
          }
          return '<div>设备分布</div>'+'<div>'+params[0].name +' : '+ params[0].seriesName+' '+ vals+'%</div>'
        }
      }
      let part5Echart6Sum = 0
      this.pageOrderDistri.device_distribution.forEach(function(item,i){
        part5Echart6Sum+=item.value
      })
      this.pageOrderDistri.device_distribution.forEach(function(item,i){
        part5Echart6Data.data.push((item.value*100/part5Echart6Sum).toFixed(2)-0)
        part5Echart6Data.xAxisData.push(item.key)
      })
      part5Echart6Data.maxIndex=tools.arrayMax(part5Echart6Data.data,'index')
      this.part5Echart6Data = part5Echart6Data
      if(!this.isInit){
        this.$refs.detailPart5Chart6.barChart(this.part5Echart6Data)
      }

      //part5 兴趣分布
      let part5Echart7Data={
        nodeId: "detailPart5Echart7", //节点
        data: [], //数据
        color: ["#ff5c00", "#40a0fc"],
        xAxisData: [],
        min: 0, //y轴的最小值
        max: 40, //y轴最大值
        interval: 10, //值之间的间隔
        yAxisName: "",
        tooltipName: "兴趣分布",
        unit: "%",
        maxIndex:0,
        formatter: function (params) {
          let vals=params[0].data
          if(vals>=10000){
            vals=(vals/10000).toFixed(2)+barChartInfo.unit
          }
          return '<div>年龄分布</div>'+'<div>'+params[0].name +' : '+ params[0].seriesName+' '+ vals+'%</div>'
        }
      }
      let part5Echart7Sum = 0
      this.pageOrderDistri.interest_distribution.forEach(function(item){
        part5Echart7Sum+=item.value
      })
      this.pageOrderDistri.interest_distribution= this.pageOrderDistri.interest_distribution.slice(0,8)
      this.pageOrderDistri.interest_distribution.forEach(function(item,i){
        part5Echart7Data.xAxisData.push(item.key)
        part5Echart7Data.data.push((item.value*100/part5Echart7Sum).toFixed(2)-0)
      })
      part5Echart7Data.maxIndex= tools.arrayMax(part5Echart7Data.data,'index')
     
      this.part5Echart7Data = part5Echart7Data
      if(!this.isInit){
        this.$refs.detailPart5Chart7.barChart(this.part5Echart7Data)
      }


    }


  },
  components:{
    contenr,
    LineChart3,
    LineChart2,
    BarChart,
    RadarChart,
    ChinaChart2,
    ChinaChart1,
    RingChart
  },
  watch:{
    
  },
  created(){
    this.orderID = this.$route.query.id
    if(window.performance.navigation.type===0||window.performance.navigation.type===1||window.performance.navigation.type===2){
        //判断浏览器刷新行为，清除session
        let inSalesGroup=window.sessionStorage.getItem('inSalesGroup')
        let name=window.sessionStorage.getItem('name')
        window.sessionStorage.clear()
        window.sessionStorage.setItem('inSalesGroup',inSalesGroup)
        window.sessionStorage.setItem('name',name)
    }

    // 获取订单详情
    this.$api.getDetailData.getOrderDetail('/'+this.orderID).then((res) => {
      this.pageDetailData = res.data.data
      if(this.pageDetailData.order){
        //   获取视频达人评价
        this.$api.getDetailData.getAuthorVideo('/'+this.pageDetailData.order.item_id).then((res) => {
          if(!res.data.data){return}
          let pageDarenWatchComment=res.data.data[0]
          pageDarenWatchComment.tags=pageDarenWatchComment.tags.split(',')
          let changeComment=function(commentData){
            let comment='-'
            for(let i=0;i<3;i++){
              if(commentData==='1'||commentData===1){
                comment='不满意'
              }else if(commentData==='2'||commentData===2){
                comment='满意'
              }else if(commentData==='3'||commentData===3){
                comment='非常满意'
              }
            }
            return comment
          }
          pageDarenWatchComment.score=pageDarenWatchComment.score-0
          pageDarenWatchComment.quality=changeComment(pageDarenWatchComment.quality)
          pageDarenWatchComment.experience=changeComment(pageDarenWatchComment.experience)
          pageDarenWatchComment.effect=changeComment(pageDarenWatchComment.effect)
          this.pageDarenWatchComment=pageDarenWatchComment
        })
      }
      this.part2Time1[0] = tools.setTime(this.pageDetailData.order.release_time)
      this.part2Time1[1] = tools.setTime(this.pageDetailData.order.release_time+ (24*60*60*14) )
      this.pageDetailData.item.cover_image_uri ='https://p3-tt.bytecdn.cn/obj/'+this.pageDetailData.item.cover_image_uri
      // 获取订单传播表现详情
      this.part2Time1Ajax(this.part2Time1,"分日数据") 
      this.part3Time1 = this.part2Time1 
      this.part3Time1Ajax(this.part3Time1,"分日数据")
      // console.log(this.pageDetailData)
      // console.log(this.pageDetailData.order.component_type)
    })

    //头部数据
    // this.pageSuccessExample = JSON.parse(window.sessionStorage.getItem('getSuccessExample')).data.data;
    // this.pagePart1Data1 = this.pageSuccessExample[window.sessionStorage.getItem('clickIndex')]
    // this.pagePart1Data1.create_time = this.pagePart1Data1.create_time.split(' ')[0]

    // 获取订单投后分析报表
    this.$api.getDetailData.getOrderOverview('/'+this.orderID).then((res) => {
      window.sessionStorage.setItem('getOrderOverview',JSON.stringify(res));
      this.pageOrderOverview= JSON.parse(window.sessionStorage.getItem('getOrderOverview')).data.data
      // part1 pagePart1Data2
      let pagePart1Data2 = {
        play:this.pageOrderOverview.spread.play,
        like:this.pageOrderOverview.spread.like,
        comment:this.pageOrderOverview.spread.comment,
        share:this.pageOrderOverview.spread.share,
        click:this.pageOrderOverview.convert.click,
      }
      for(var key in pagePart1Data2){
        pagePart1Data2[key]= this.toChangeW(pagePart1Data2[key])
      }
      this.pagePart1Data2 = pagePart1Data2
      // part1 pagePart1Data3
      console.log(this.pageOrderOverview.cost_effectiveness)
      let pagePart1Data3 ={
        // price:this.pageOrderOverview.cost_effectiveness.price/1000,
        play:this.pageOrderOverview.cost_effectiveness.play,
        cpm:this.pageOrderOverview.cost_effectiveness.cpm
      }
      for(var key in pagePart1Data3){
        pagePart1Data3[key]= this.toChangeW(pagePart1Data3[key])
      }
      pagePart1Data3.price = this.pageOrderOverview.cost_effectiveness.price/100
      this.pagePart1Data3 = pagePart1Data3

      // part1 pagePart1Data5
      let pagePart1Data5 = {
        neg_rate:parseInt(this.pageOrderOverview.comment.neg_rate/100),
        pos_rate:parseInt(this.pageOrderOverview.comment.pos_rate/100),
        neu_rate:parseInt(this.pageOrderOverview.comment.neu_rate/100),
        high_frequency_words:this.pageOrderOverview.comment.high_frequency_words
      }
      if(pagePart1Data5.high_frequency_words.length>6){
        pagePart1Data5.high_frequency_words = pagePart1Data5.high_frequency_words.slice(0,6)
      }
      this.pagePart1Data5 = pagePart1Data5

      // part1 pagePart1Data6
      let pagePart1Data6={
        click:this.toChangeW(this.pageOrderOverview.convert.click),
        ctr:this.pageOrderOverview.convert.ctr/100
      }
      this.pagePart1Data6 = pagePart1Data6

      // part1 pagePart1Data7
      let pagePart1Data7={
        five_s_play_rate:this.pageOrderOverview.creative.five_s_play_rate/100,
        finish_rate:this.pageOrderOverview.creative.finish_rate/100,
        play_rate:this.pageOrderOverview.creative.play_rate/100
      }
      this.pagePart1Data7 = pagePart1Data7

      // part6
      this.pagePart6Data1 =this.pageOrderOverview.comment.high_frequency_words
      this.part6Echart2Data.data[0].value=this.pageOrderOverview.comment.neg_rate/100
      this.part6Echart2Data.data[1].value=this.pageOrderOverview.comment.pos_rate/100
      this.part6Echart2Data.data[2].value=this.pageOrderOverview.comment.neu_rate /100
      this.$refs.detailPart6Chart2.ringChart(this.part6Echart2Data)

    })

    // 获取订单用户画像
    this.part5DataAjax("播放")


    // 获取订单投后受众报表
    this.$api.getDetailData.getOrderUser('/'+this.orderID).then((res) => {
      window.sessionStorage.setItem('getOrderUser',JSON.stringify(res));
      this.pageOrderUser= JSON.parse(window.sessionStorage.getItem('getOrderUser')).data.data
    })
  
    // 获取订单指数详情
    this.$api.getDetailData.getOrderBasic('/'+this.orderID).then((res) => {
      this.pageOrderBasic = res.data.data
    })

    // 获取订单转化详情
    this.$api.getDetailData.getOrderConvert('/'+this.orderID).then((res) => {
      this.pageOrderConvert = res.data.data
    })

    


    // 获取实时数据
    this.part2Time2Ajax(tools.setTime((new Date().getTime())/1000))

    

    // 获取订单指数
    this.$api.getDetailData.getOrderBase('/'+this.orderID).then((res) => {
      this.pageOrderBase = res.data.data
      this.upDateTime = tools.setTime(parseInt(this.pageOrderBase.update_time))
    })
    
    // 获取订单指数
    this.$api.getDetailData.getOrderWatch('/'+this.orderID).then((res) => {
      this.pageOrderWatch = res.data.data
      let part4Echart1Data={
        nodeId:'detailPart4Echart1',//节点
        data: [],//数据
        smooth:true,//平滑
        xAxisData:[],
        // min:14, //y轴的最小值
        // max:0, //y轴最大值 
        // interval:2, //值之间的间隔
        yAxisName: '',
        tooltipName2:'观看时长',
        tooltipName:'用户占比',
        unit:'%'
      }

      let sum =this.pageOrderWatch.watch_distribution?tools.arraySum(this.pageOrderWatch.watch_distribution):0
      this.pageOrderWatch.watch_distribution&&this.pageOrderWatch.watch_distribution.forEach(function(item,i){
        part4Echart1Data.xAxisData.push((i+2)+'s')
        part4Echart1Data.data.push(((item/sum)*100).toFixed(1)-0)
      })
      this.part4Echart1Data = part4Echart1Data
      this.$refs.detailPart4Chart1.lineChart(this.part4Echart1Data)

    })

    // 获取订单创意解析详情
    this.$api.getDetailData.getOrderCreative('/'+this.orderID).then((res) => {
      this.pageOrderCreative = res.data.data
      let part4Echart2Data={
        nodeId:'detailPart4Echart2',//节点
        max:[{text: '内容吸引力 '+this.pageOrderCreative.content_appeal.level, max: 100},{text: '内容韧性 '+this.pageOrderCreative.content_resilience.level, max: 100},{text: '第一印象 '+this.pageOrderCreative.first_impression.level, max: 100}],
        data1:[0,0,0],
        data2:[0,0,0]
      }
      if(this.pageOrderCreative.content_appeal.level==="S"){
        part4Echart2Data.data2[0]=100
      }else if(this.pageOrderCreative.content_appeal.level==="A"){
        part4Echart2Data.data2[0]=66
      }else if(this.pageOrderCreative.content_appeal.level==="B"){
        part4Echart2Data.data2[0]=33
      }else if(this.pageOrderCreative.content_appeal.level==="C"){
        part4Echart2Data.data2[0]=0
      }
      if(this.pageOrderCreative.content_resilience.level==="S"){
        part4Echart2Data.data2[1]=100
      }else if(this.pageOrderCreative.content_resilience.level==="A"){
        part4Echart2Data.data2[1]=66
      }else if(this.pageOrderCreative.content_resilience.level==="B"){
        part4Echart2Data.data2[1]=33
      }else if(this.pageOrderCreative.content_resilience.level==="C"){
        part4Echart2Data.data2[1]=0
      }
      if(this.pageOrderCreative.first_impression.level==="S"){
        part4Echart2Data.data2[2]=100
      }else if(this.pageOrderCreative.first_impression.level==="A"){
        part4Echart2Data.data2[2]=66
      }else if(this.pageOrderCreative.first_impression.level==="B"){
        part4Echart2Data.data2[2]=33
      }else if(this.pageOrderCreative.first_impression.level==="C"){
        part4Echart2Data.data2[2]=0
      }

      this.part4Echart2Data = part4Echart2Data
      this.$refs.detailPart4Chart2.radarChart(this.part4Echart2Data)
    })
  


  
  },
  mounted(){
    this.isInit=false
  }
}
</script>

<style scoped>
  .part1 .grade{
    margin-top: 30px;
    width: 100%;
    background: #FFFFFF;
    padding: 30px;
    padding-bottom: 0;
    border-top: 1px solid #F5F5F6;
    box-sizing: border-box;
  }
  .part1 .grade .title{
    display: block;
    width: 100%;
    height: 50px;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
    border-bottom: 1px solid #F5F5F6;
  }
  .part1 .grade .title2{
    width: 100%;
    height: 65px;
    margin-top: 0;
    padding-top: 30px;
    box-sizing: border-box;
  }
  .part1 .grade .comment{
    width: 100%;
    background: #F8F8F8;
    border-radius: 6px;
    padding: 20px 30px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #888888;
    line-height: 32px;
  }

  .part1 .grade .gradeContent{
    width: 100%;
    height: 230px;
  }
  .part1 .grade .gradeContent .scort{
    padding-left: 360px;
    height: 60px;
    box-sizing: border-box;
  }
  .part1 .grade .gradeContent .scort>>>.el-rate__icon{
    font-size: 60px;
  }
  .part1 .grade .gradeContent .scort>>>.el-rate__text{
    font-size: 40px;
  }
  .part1 .grade .gradeContent .tags{
    margin-top: 30px;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 50px;
  }
  .part1 .grade .gradeContent .tags span{
    padding: 12px 20px;
    margin: 0 10px;
    font-size: 16px;
    background: #FFF2EB;
    border-radius: 6px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #FF6F28;
    line-height: 32px;
  }
  .part1 .grade .gradeContent .tags2{
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 36px;
    padding: 0 120px;
    box-sizing: border-box;
    
  }

  .part1 .grade .gradeContent .tags2 .tagItem{
    margin-top: 40px;
    width: 260px;
  }
  .part1 .grade .gradeContent .tags2 .tagItem span:nth-of-type(1){
    float: left;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #666666;
    line-height: 36px;
  }
  .part1 .grade .gradeContent .tags2 .tagItem span:nth-of-type(2){
    float: left;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #FF9A16;
    line-height: 36px;
  }
  .part1 .grade .gradeContent .tags2 .tagItem img{
    float: left;
    display: inline-block;
    width: 36px;
    height: 36px;
    margin-left: 17px;
    margin-right: 11px;
  }




  .part1Echar1Nodata{
    position: absolute;
    width: 1170px;
    height: 430px;
    margin-top: 20px;
    box-sizing: border-box;
    padding-top: 140px;
    background: #fff;
    z-index: 9;
  }
  .part1Echar2Nodata{
    position: absolute;
    width: 1170px;
    height: 430px;
    margin-top: 20px;
    box-sizing: border-box;
    padding-top: 140px;
    background: #fff;
    z-index: 9;
  }
  .part1Echar2Nodata{
    position: absolute;
    width: 1170px;
    height: 450px;
    margin-top: 20px;
    box-sizing: border-box;
    padding-top: 140px;
    background: #fff;
    z-index: 9;
  }
  .noData{
    margin: auto;
    text-align: center;
    color: #999;
  }
  .noData img{
    display: block;
    margin: auto;
    margin-bottom: 30px;
  }
  .part2{
    height: 1240px;
    margin-top: 40px;
  }
  .part2 .title2{
    margin-bottom: 10px;
  }
  .part2 .title2 .block{
    float: right;
  }
  .part3 .chooseTime,
  .part2 .chooseTime{
    float: right;
    margin-top: -52px;
  }
  .detailContainer>>>.el-input__inner{
    border: 0;
  }
  .part2 .chooseTime .time{
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #666666;
  }
  .part2 .chooseTime .chooseTimeHr{
    display: inline-block;
    margin: 0 18px;
    width: 1px;
    height: 12px;
    background: #EAEAEA ;
  }
  .part2>>>.el-dropdown-menu__item:focus,
  .part3>>>.el-dropdown-menu__item:focus{
    color: #FF5C00;
    background: #F5F5F5;
  }
  .part2>>>.el-dropdown-menu__item:not(.is-disabled):hover,
  .part3>>>.el-dropdown-menu__item:not(.is-disabled):hover{
    color: #FF5C00;
    background: #F5F5F5;
  }
  .part2 #detailPart2Echart1{
    width: 100%;
    height: 430px;
    margin-top: 20px;
  }
  .part2 #detailPart2Echart2{
    width: 100%;
    height: 430px;
    margin-top: 30px;
  }




  .part3{
    height: 650px;
    margin-top: 40px;
  }
  .part3 #detailPart3Echart1{
    width: 100%;
    height: 430px;
    margin-top: 30px;
  }
  
  .detailContainer>>>.el-tabs__nav-wrap::after{
    background-color:transparent;
    border-bottom: 1px solid #F5F5F6;
  }
  .detailContainer>>>.el-tabs__item{
    color:#999;
  }
  .detailContainer>>>.el-tabs__item.is-active{
    color: #FF5C00;
  }
  .detailContainer>>>.el-tabs__active-bar{
    background-color:#FF5C00;
  }

  .partTitle {
    width: 100%;
    height: 80px;
  }
  .partTitle .partTitleLeft{
    float: left;
    width: 60%;
  }
  .partTitle .partTitleLeft i{
    float: left;
    width: 1px;
    height: 10px;
    margin: 15px 14px 0;
    background: #EAEAEA;
  }
  .partTitle .partTitleLeft .partTitleLeftTit{
    display: block;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .partTitle .partTitleLeft p{
    float: left;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }
  .partTitle .progress{
    float: right;
  }
  .part .hr{
    width: 1200px;
    height: 1px;
    margin-left: -30px;
    border-bottom: 1px solid #F5F5F6;
  }
  .partTitle .more{
    float: right;
    width: auto;
    padding: 0 4px;
    margin-top: 13px;
    margin-right: 30px;
  }
  .ItemContainer{
    float: left;
    margin-top: 30px;
    margin-right: 30px;
    width: 554px;
  }
  .ItemContainer .ItemTitle{
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }

  .title2{
    display: block;
    margin-top: 30px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .more{
    display: block;
    width: 128px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background: #F4F4F5;
    border-radius: 2px;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
  }
  .more em{
    color: #333;
    font-style: normal;
    margin: 0 3px;
  }
  .progress{
    float: left;
    position: relative;
    width: 50px;
    height: 50px;
  }
  .progress i{
    position: absolute;
    top:0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #333333;
  }
  .clear:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .clear {
    *zoom: 1;
    /*ie6清除浮动的方式 *号只有IE6-IE7执行，其他浏览器不执行*/
  }
  .detailContainer{
    width: 1200px;
    margin: 20px auto;
  }
  .detailContainer .part{
    width: 100%;
    padding: 30px;
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
  }
  .detailContainer .part1{
    overflow: hidden;
    /* height: 1170px;
    height: 1240px; */
  }
  .part1 .topName{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #666666;
  }
  .part1 h3{
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .part1 .topInfo{
    width: 100%;
  }
  .part1 .topInfo span{
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }
  .part1 .topInfo i{
    display: inline-block;
    width: 1px;
    height: 10px;
    margin: 0 14px;
    background: #EAEAEA;
  }
  .part1 .content{
    width: 100%;
    height: 100px;
    margin-top: 30px;
  }
  .part1 .content .backImg{
    float: left;
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
  }
  .part1 .content .backImg::before{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .3);
  }
  .part1 .content .backImg::after{
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 40px;
    height: 40px;
    margin: auto;
    background: url("./images/icon_play.png") no-repeat center;
    background-size: cover;
  }
  .part1 .content .backImg img{
    display: block;
    width: 100%;
    height: 100%;
  }
  .part1 .content .contentDetail{
    float: left;
    width: 260px;
    margin-left: 30px;
  }
  .part1 .content .contentDetail a{
    display: block;
  }
  .part1 .content .contentDetail p a{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 24px;
  }
  .part1 .content .contentDetail span a{
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }
  .part1 .content .contentRight{
    float: right;
    margin-top: 36px;
  }
  .part1 .content .contentRight .rightItem{
    float: left;
    width: 140px;
    height: 48px;
    padding-left: 30px;
    border-right: 1px solid #F0F0F0;
    box-sizing: border-box;
  }
  .part1 .content .contentRight .rightItem:nth-last-of-type(1){
    border: 0;
  }
  .part1 .content .contentRight .rightItem span{
    display: block;
    margin-bottom: 10px;
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #333333;
  }
  .part1 .content .contentRight .rightItem i{
    display: block;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #666666;
  }
  .part1 .index{
    width: 1200px;
    height: 124px;
    margin-top: 40px;
    margin-left: -30px;
    padding-left: 30px;
    background: #FFFAF7;
    box-sizing: border-box;
  }
  .part1 .index .progress1{
    float: left;
    position: relative;
    width: 64px;
    height: 64px;
    margin-top: 30px;
  }
  .part1 .index .progress1 i{
    position: absolute;
    top:0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    line-height: 64px;
    text-align: center;
    font-size: 28px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #333333;
  }
  .part1 .index span:nth-of-type(1){
    float: left;
    line-height: 124px;
    margin-left: 30px;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .part1 .index .more{
    float: left;
    margin-top: 50px;
    margin-left: 16px;
    width: 116px;
    height: 24px;
    background: #F4F4F5;
    border-radius: 2px;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
    text-align: center;
  }
  .part1 .index .more u{
    color: #333;
    margin: 0 3px;
    line-height: 24px;
  }
  .part1 .listItem{
    float: left;
    width: 530px;
    height: 240px;
    margin-right: 80px;
    padding-top: 50px;
    box-sizing: border-box;
  }
  .part1 .listItem:nth-of-type(2n){
    margin-right: 0;
  }
  .part1 .listItem .listTitle{
    float: left;
    width: 50%;
    height: 50px;
    margin-left: 20px;
  }
  .part1 .listItem .listTitle span{
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .part1 .listItem .listTitle .more{
    margin-top: 3px;
  }
  .part1 .listItem .toWhere{
    float: right;
    width: 100px;
    height: 34px;
    background: #FF5C00;
    border-radius: 4px;
    font-size: 15px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 34px;
    text-align: center;
  }
  .part1 .listItem ul{
    width: 100%;
    height: 42px;
    margin-top: 90px;
    padding-left: 0;
  }
  .part1 .listItem ul li{
    float: left;
    width: 110px;
    height: 100%;
    margin-left: 20px;
    border-right: 1px solid #F0F0F0;
    box-sizing: border-box;
  }
  .part1 .listItem ul li:nth-last-of-type(1){
    border-right: 0;
  }
  .part1 .listItem ul li span{
    display: block;
    margin-bottom: 4px;
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #333333;
  }
  .part1 .listItem ul li i{
    display: block;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #666666;
  }
  .part1 .listItem .listBottom .bottomTitle{
    display: block;
    margin-top: 90px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .part1 .listItem .listBottom .bottomContent{
    width: 100%;
    height: 50px;
    margin-top: 24px;
  }
  .part1 .listItem .listBottom .bottomContent img{
    float: left;
    width: 50px;
    height: 50px;
  }
  .part1 .listItem .listBottom .bottomContent .bottomOther{
    float: left;
    width: 80%;
    margin-left: 20px;
  }
  .part1 .listItem .listBottom .bottomContent .bottomOther i{
    display: block;
    margin-bottom: 9px;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
  }
  .part1 .listItem .listBottom .bottomContent .bottomOther u{
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
  }
  .part1 .listItem .listBottom .bottomContent .bottomOther span{
    display: inline-block;
    height: 26px;
    margin-right: 10px;
    margin-bottom: 6px;
    padding: 0 10px;
    line-height: 26px;
    background: #F4F4F5;
    border-radius: 2px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .part1 .listItem .listBottom .analysis{
    width: 90%;
    height: 60px;
    margin-top: 20px;
  }
  .part1 .listItem .listBottom .analysis .analysisItem{
    float: left;
  }
  .part1 .listItem .listBottom .analysis .analysisItem span{
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .part1 .listItem .listBottom .analysis .analysisItem i{
    position: relative;
    display: block;
    background: #DDDDDD;
    width: 100%;
    height: 6px;
    margin: 7px 0;
    box-sizing: border-box;
  }
  .part1 .listItem .listBottom .analysis .analysisItem i::after{
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 4px;
    height: 6px;
    background: #fff;
  }
  .part1 .listItem .listBottom .analysis .analysisItem:nth-of-type(1) i{
    background: #31C270;
  }
  .part1 .listItem .listBottom .analysis .analysisItem:nth-of-type(2) i{
    background: #FF823B;
  }
  .part4{
    height: 640px;
    margin-top: 40px;
  }
  .part4 .ItemContainer:nth-of-type(2n){
    margin-right: 0;
  }
  .part4 .ItemContainer .part4List1{
    overflow: hidden;
    padding-left: 0;
  }
  .part4 .ItemContainer .part4List1 li{
    float: left;
    width: 130px;
    height: 48px;
    padding-left: 20px;
    border-right: 1px solid #F0F0F0;
    box-sizing: border-box;
  }
  .part4 .ItemContainer .part4List1 li:nth-last-of-type(1){
    border: 0;
  }
  .part4 .ItemContainer .part4List1 li span{
    display: block;
    margin-bottom: 6px;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 800;
    color: #333333;
  }
  .part4 .ItemContainer .part4List1 li i{
    display: block;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #666666;
  }
  .part4 .ItemContainer .part4List2{
    padding-left: 0;
  }
  .part4 .ItemContainer .part4List2 li span{
    display: inline-block;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .part4 .ItemContainer .part4List2 li span:nth-of-type(1){
    width: 70px;
  }
  .part4 .ItemContainer .part4List2 li span:nth-of-type(2){
    color: #999;
  }
  .part4 .ItemContainer .part4List2 li i{
    display: inline-block;
    width: 16px;
    margin: 0 15px 14px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #FF6F28;
  }
  .part4 #detailPart4Echart1{
    width: 554px;
    height: 360px;
  }
  .part4 #detailPart4Echart2{
    width: 554px;
    height: 300px;
    margin-top: 40px;
  }

  .part5{
    height: 1410px;
    margin-top: 40px;
  }
  #detailPart5Echart1{
    width: 570px;
    height: 260px;
  }
  #detailPart5Echart2{
    width: 570px;
    height: 260px;
  }
  .part5 .userChoose{
    width: 100%;
    height: 96px;
    border-bottom: 1px solid #F5F5F6;
  }
  .part5 .userChoose span{
    float: left;
    line-height: 96px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .part5 .userChoose i{
    float: left;
    margin-top: 30px;
    margin-left: 10px;
    padding: 0 17px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
    cursor: pointer;
    background: #F4F4F5;
    border-radius: 2px;
  }
  .part5 .userChoose i.active{
    background: #FF7936;
    color: #fff;
  }

  .part5 .title2{
    margin-bottom: 10px;
    margin-top: 0;
  }
  .part5 .part5Line1{
    width: 100%;
    height: 350px;
    margin-top: 30px;
  }
  .part5 .part5Line1 .part5Chart1Container{
    float: left;
    position: relative;
    width: 50%;
  }
  .part5 .part5Line1 .part5Chart1Container .left{
    position: absolute;
    bottom: 30px;
    left: 30px;
    width: 12px;
    height: 84px;
    background-image: linear-gradient(to bottom, #38a1ff, #e0f1ff);
  }

  .part5 .part5Line1 .part5Chart1Container .left::before{
    content: "高";
    position: absolute;
    bottom: 90px;
    left: 0px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .part5 .part5Line1 .part5Chart1Container .left::after{
    content: "低";
    position: absolute;
    bottom: -24px;
    left: 0px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .part5 .more{
    width: auto;
    text-align:left;
    background: transparent;
    font-size: 14px;
  }
  .part5 .part5Line1 .part5Chart2Container{
    float: left;
    width: 50%;
    padding-left: 60px;
    box-sizing: border-box;
  }
  .part5 .part5Line1 .part5Chart2Container>>>.el-progress-bar__outer{
    cursor: pointer;
  }
  .part5 .part5Line1 .part5Chart2Container>>>.el-progress-bar__outer:hover .el-progress-bar__inner{
    background:#1676E4;
  }
  .part5 .part5Line1 .part5Chart2Container .part5Progress{
    position: relative;
    float: right;
    width: 460px;
    margin-top: 30px;
    padding-right: 60px;
    box-sizing: border-box;
  }
  .part5 .part5Line1 .part5Chart2Container .part5Progress span{
      position: absolute;
      left: -50px;
      font-size: 14px;
      font-family: OPPOSans;
      font-weight: 500;
      color: #333333;
  }
  .part5 .part5Line1 .part5Chart2Container .part5Progress>>>.el-progress{
    margin-bottom: 24px;
  }
  .part5 .part5Line1 .part5Chart2Container .part5Progress>>>.el-progress-bar__inner{
    background: linear-gradient(90deg, #1A7DFC, #4DACFC);
  }
  .part5 .part5Line1 .part5Chart2Container .part5Progress>>>.el-progress__text{
    color: #2784FF;
  }
  .part5 .part5Echart3Container{
    float: left;
    width: 33%;
    height: 360px;
    margin-top: 40px;
    border-right: 1px solid #F5F5F6;
  }
  .part5 #detailPart5Echart3{
    width: 360px;
    height: 220px;
    margin-top: 20px;
  }
  .part5 .part5Echart3Container .bottom{
    width: 100px;
    height: 40px;
    margin-top: 20px;
    margin-left: 30px;
    overflow: hidden;
  }
  .part5 .part5Echart3Container .bottom img{
    float: left;
    width: 30px;
    height: 30px;
    margin-top: 4px;
  }
  .part5 .part5Echart3Container .bottom .bottomRight{
    float: left;
    margin-left: 10px;
  }
  .part5 .part5Echart3Container .bottom .bottomRight span{
    display: block;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
  }
  .part5 .part5Echart3Container .bottom .bottomRight i{
    display: block;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #40A0FC;
  }
  .part5 .part5Echart3Container .bottom:nth-of-type(2){
    float: right;
    margin-right: 30px;
  }
  .part5 .part5Echart4Container{
    float: left;
    width: 33%;
    height: 360px;
    margin-top: 40px;
    padding: 0 20px;
    border-right: 1px solid #F5F5F6;
    box-sizing: border-box;
  }
  .part5 #detailPart5Echart4{
    width: 340px;
    height: 280px;
    margin-top: 10px;
  }
  .part5 .part5Echart5Container{
    float: left;
    width: 33%;
    height: 360px;
    margin-top: 40px;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .part5 #detailPart5Echart5{
    width: 340px;
    height: 220px;
    margin-top: 60px;   
  }
  .part5 .part5Echart6Container{
    float: left;
    width: 48%;
    height: 320px;
    margin-top: 40px;
    padding: 0 20px;
    box-sizing: border-box;
    border-right: 1px solid #F5F5F6;
  }
  .part5 #detailPart5Echart6{
    width: 500px;
    height: 260px;
    margin-top: 10px;  
  }
  .part5 .part5Echart7Container{
    float: left;
    width: 50%;
    height: 320px;
    margin-top: 40px;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .part5 #detailPart5Echart7{
    width: 560px;
    height: 260px;
    margin-top: 10px;  
  }
  .part6{
    height: 480px;
    margin-top: 40px;
  }
  .part6 .part6Echart1Container{
    float: left;
    width: 50%;
    height: 340px;
  }
  .part6 .part6Echart2Container{
    float: left;
    width: 50%;
    height: 340px;
  }
  .part6 #detailPart6Echart2{
    width: 400px;
    height: 220px;
    margin-top: 50px;
    margin-left: 90px;
  }
  .hotword {
      position: relative;
      margin-top: 30px;
      margin-left: 90px;
      width: 340px;
      height: 260px;
  }
  .hotword  span{
      position: absolute;
      font-size: 16px;
      font-family: OPPOSans;
      font-weight: 500;
      color: #38A1FF;
  }
  .hotword  span:nth-of-type(1){
      top: 80px;
      left: 80px;
      font-size: 60px;
      color: #FF5C00;
  }
  .hotword  span:nth-of-type(2){
      top: 54px;
      left: 100px;
      font-size: 24px;
      color: #FF5C00;
  }
  .hotword  span:nth-of-type(3){
      top: 56px;
      left: 200px;
      font-size: 20px;
      color: #FFA555;
  }
  .hotword  span:nth-of-type(4){
      top: 160px;
      left: 110px;
      font-size: 20px;
      color: #FFA555;
  }
  .hotword  span:nth-of-type(5){
      top: 180px;
      left: 160px;
      font-size: 20px;
      color: #FF5C00;
  }
  .hotword  span:nth-of-type(6){
      top: 160px;
      left: 220px;
      font-size: 18px;
      color: #FFA555;
  }
  .hotword  span:nth-of-type(7){
      top: 30px;
      left: 120px;
      font-size: 16px;
      color: #38A1FF;
  }
  .hotword  span:nth-of-type(8){
      top: 100px;
      left: 10px;
      font-size: 14px;
      color: #38A1FF;
  }
  .hotword  span:nth-of-type(9){
      top: 130px;
      left: 26px;
      font-size: 14px;
      color: #38A1FF;
  }
  .hotword  span:nth-of-type(10){
      top: 200px;
      left: 80px;
      font-size: 14px;
      color: #38A1FF;
  }
  .hotword  span:nth-of-type(11){
      top: 200px;
      left: 240px;
      font-size: 14px;
      color: #38A1FF;
  }


</style>